import { render, staticRenderFns } from "./CertificateUpload.vue?vue&type=template&id=2fb04a13&scoped=true&"
import script from "./CertificateUpload.vue?vue&type=script&lang=js&"
export * from "./CertificateUpload.vue?vue&type=script&lang=js&"
import style0 from "./CertificateUpload.vue?vue&type=style&index=0&id=2fb04a13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb04a13",
  null
  
)

export default component.exports